export var types = {
    CATIZ_INTERNAL_CHANGE_TP_STATE: 'CATIZ_INTERNAL_CHANGE_TP_STATE',
};
export var setCatizInternalChangeTPState_AC = function (panelSetType, panelValue) {
    return {
        type: types.CATIZ_INTERNAL_CHANGE_TP_STATE,
        payload: {
            panelSetType: panelSetType,
            panelValue: panelValue,
        },
    };
};
//# sourceMappingURL=catiz_touchpanel.actions.js.map